import { render, staticRenderFns } from "./UnihallQuotaSelectbox.vue?vue&type=template&id=7803b88a"
import script from "./UnihallQuotaSelectbox.vue?vue&type=script&lang=js"
export * from "./UnihallQuotaSelectbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports